import React, { useEffect } from 'react'

import { useAuth } from '@/hooks/useAuth'

type HelpScoutBeacon = {
  (method: 'identify', user: { email: string; name?: string }): void
  (method: 'logout'): void
}

export const HelpScout: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuth()

  useEffect(() => {
    const beacon = (window as typeof window & { Beacon?: HelpScoutBeacon })
      .Beacon

    if (isLoading || !beacon) {
      return
    }

    if (isAuthenticated && user?.email) {
      beacon('identify', {
        email: user.email,
        ...(user.name && { name: user.name }),
      })
      return
    }

    beacon('logout')
  }, [isAuthenticated, isLoading, user?.email, user?.name])

  return null
}
